'use strict';

var _ = require('lodash');
var OverridesPreparationService = function OverridesPreparationService(configurationService, scenarioConstants, overridesConstants, overridesKeyService, overridesUtilsService) {
  var DEFAULTS = {
    VALUE_TYPE: 'O',
    SCENARIO: scenarioConstants.PUBLISHED
  };
  var gridToDomainMapping = require('../config/gridToDomainConfig.json');
  function getDomain(gridId, fieldId) {
    var domain = _.get(gridToDomainMapping, gridId);
    return _.isObject(domain) ? _.get(domain, fieldId, domain.defaultDomain) : domain;
  }

  /**
   * Returns helper object with information about clearing and setting overrides
   * @param overrides
   * @param override
   * @return {{clearOverrideIndex: *, isSettingOverride: boolean, setOverrideIndex: *}}
   */
  function getClearSetInfo(overrides, override) {
    var isSettingOverride = override.value !== '';
    var clearOverrideIndex = _.findIndex(overrides, function (o) {
      return o.value === '';
    });
    var setOverrideIndex = _.findIndex(overrides, function (o) {
      return o.value !== '';
    });
    return {
      isSettingOverride: isSettingOverride,
      clearOverrideIndex: clearOverrideIndex,
      setOverrideIndex: setOverrideIndex
    };
  }

  /**
   * Removes all clearing overrides, the ones with '' in value
   * @param clearSetInfo
   * @param overrides
   */
  function removeUnneededClearingOverrides(clearSetInfo, overrides) {
    while (clearSetInfo.clearOverrideIndex !== -1) {
      overrides.splice(clearSetInfo.clearOverrideIndex, 1);
      clearSetInfo.clearOverrideIndex = _.findIndex(overrides, function (o) {
        return o.value === '';
      });
    }
  }
  function prepareKey(domain, row, key) {
    var overrideKey = overridesKeyService.buildOverrideKey(domain, row, key);
    var fieldToSave = overridesUtilsService.stripSegClass(key);
    fieldToSave = overridesUtilsService.prefixNestedField(fieldToSave);
    return _.extend({
      field: fieldToSave,
      domain: domain
    }, overrideKey);
  }
  function assignValue(override, row, key) {
    var valueType = overridesUtilsService.getValueType(row, key) || DEFAULTS.VALUE_TYPE;
    var assignedValue = overridesUtilsService.handleZeroValue(row, key);
    return _.assign(override, {
      type: valueType,
      value: valueType === 'A' && assignedValue === '' ? null : assignedValue
    });
  }
  function assignType(override, row, key) {
    return _.assign(override, {
      type: overridesUtilsService.handleZeroValue(row, key),
      value: overridesUtilsService.getTypeValue(row, key) || ''
    });
  }
  function adjacentOverrideValueDoesNotExist(row, key) {
    var adjacentOverrideKey = overridesUtilsService.getAdjacentOverrideKey(key);
    return !row[adjacentOverrideKey] && row[adjacentOverrideKey] !== 0;
  }
  function overridesDoNotContainDuplicate(overrides, overrideToSearchFor) {
    return _.find(overrides, overrideToSearchFor) === undefined;
  }

  /**
   * Builds payload for simple overrides - with no complex logic behind them like minMax or auth/avail linkType
   * @param row
   * @param domain
   * @param fieldId
   * @return {Array}
   */
  function buildSimpleOverridesDetails(row, domain, fieldId) {
    var overrides = [];
    var override = prepareKey(domain, row, fieldId);
    if (overridesUtilsService.overrideMinType(fieldId) || overridesUtilsService.overrideMaxType(fieldId) || overridesUtilsService.authLinkType(fieldId) || overridesUtilsService.isUserSegmentLimit(fieldId) || overridesUtilsService.isUserSegmentLimitType(fieldId)) {
      return [];
    }
    if (overridesUtilsService.isManuallyControlled(fieldId)) {
      var clonedRow = _.cloneDeep(row);
      assignValue(override, _.assign(clonedRow, {
        isManuallyControlled: clonedRow.isManuallyControlled === 'Yes'
      }), fieldId);
    } else if (!overridesUtilsService.isValueType(fieldId)) {
      assignValue(override, row, fieldId);
    } else {
      assignType(override, row, fieldId);
    }
    overrides.push(override);
    return overrides;
  }
  function prepareSimpleOverrides(row, gridId) {
    var simpleOverrides = [];
    _.forEach(row._old, function (v, fieldId) {
      var actualField = fieldId;
      if (overridesUtilsService.isEffective(actualField)) {
        return;
      }
      if (overridesUtilsService.isRtpField(actualField)) {
        var demandField = overridesUtilsService.getDemandField(actualField);
        if (!_.has(row._old, demandField) && !_.isNil(row[demandField])) {
          actualField = demandField;
        } else {
          return;
        }
      }
      var domain = getDomain(gridId, actualField);
      if (!domain) {
        throw new Error('No domain mapping for grid: ' + gridId + ' and field: ' + actualField + ' when saving user adjustments.');
      }
      simpleOverrides = _.concat(simpleOverrides, buildSimpleOverridesDetails(row, domain, actualField));
    });
    return simpleOverrides;
  }
  function assignUserSegmentLimitTypeValue(override, row, key) {
    return _.assign(override, {
      type: DEFAULTS.VALUE_TYPE,
      value: overridesUtilsService.handleSegmentLimitType(row, key) || 0
    });
  }
  function prepareSegmentLimitTypeOverride(domain, row, key) {
    var userSegmentLimitValue = row[key];
    var override = prepareKey(domain, row, overridesConstants.USER_SEGMENT_LIMIT_TYPE);
    assignUserSegmentLimitTypeValue(override, row, overridesConstants.USER_SEGMENT_LIMIT_TYPE);
    // if value is null then user want delete override
    if (!userSegmentLimitValue) {
      override.value = '';
    }
    return override;
  }
  function prepareHardOverrideTypeOverride(domain, row, key) {
    var userHardOverrideTypeValue = row[key];
    var override = prepareKey(domain, row, overridesConstants.HARD_OVERRIDE_TYPE);
    assignValue(override, row, overridesConstants.HARD_OVERRIDE_TYPE);

    // if value is null then user want delete override
    if (userHardOverrideTypeValue || userHardOverrideTypeValue === 0) {
      override.value = overridesUtilsService.isAuthOverride(key) ? 'AUTH' : 'AVAIL';
    } else {
      override.value = '';
    }
    return override;
  }
  function prepareMinMaxOverrides(row, gridId) {
    var minMaxOverrides = [];
    _.forEach(row._old, function (v, fieldId) {
      var actualField = fieldId;
      var domain = getDomain(gridId, actualField);
      if (!domain) {
        throw new Error('No domain mapping for grid: ' + gridId + ' and field: ' + actualField + ' when saving user adjustments.');
      }
      if (!overridesUtilsService.overrideMinType(fieldId) && !overridesUtilsService.overrideMaxType(fieldId)) {
        return;
      }
      var hardOverrideTypeMinMax = prepareKey(domain, row, fieldId);
      assignValue(hardOverrideTypeMinMax, row, fieldId);
      hardOverrideTypeMinMax.field = overridesUtilsService.overrideMinType(fieldId) ? overridesConstants.HARD_OVERRIDE_MIN_VALUE : overridesConstants.HARD_OVERRIDE_MAX_VALUE;
      var clearSetInfo = getClearSetInfo(minMaxOverrides, hardOverrideTypeMinMax);
      if (clearSetInfo.isSettingOverride && clearSetInfo.clearOverrideIndex !== -1) {
        removeUnneededClearingOverrides(clearSetInfo, minMaxOverrides);
      }
      if (!clearSetInfo.isSettingOverride && clearSetInfo.setOverrideIndex !== -1) {
        // do not push clearing overrides when setting override exists
        return;
      } else {
        minMaxOverrides.push(hardOverrideTypeMinMax);
        var hardOverrideType = prepareHardOverrideTypeOverride(domain, row, fieldId);
        if ((hardOverrideType.value || adjacentOverrideValueDoesNotExist(row, fieldId)) && overridesDoNotContainDuplicate(minMaxOverrides, hardOverrideType)) {
          minMaxOverrides.push(hardOverrideType);
        }
      }
    });
    return minMaxOverrides;
  }
  function prepareLinkTypeOverride(domain, row, key) {
    var userLinkTypeValue = row[key];
    var override = prepareKey(domain, row, overridesConstants.LINK_TYPE);
    assignValue(override, row, overridesConstants.LINK_TYPE);

    // if value is null then user want delete override
    if (userLinkTypeValue) {
      override.value = key === overridesConstants.AUTH_LINK || key === overridesConstants.REGULAR_AUTH_LINK ? 'AUTH' : 'AVAIL';
    } else {
      override.value = '';
    }
    return override;
  }
  function prepareLinkOverrides(row, gridId) {
    var linkOverrides = [];
    _.forEach(row._old, function (v, fieldId) {
      var actualField = fieldId;
      var domain = getDomain(gridId, actualField);
      if (!domain) {
        throw new Error('No domain mapping for grid: ' + gridId + ' and field: ' + actualField + ' when saving user adjustments.');
      }
      if (!overridesUtilsService.authLinkType(fieldId)) {
        return;
      }
      var linkOverride = prepareKey(domain, row, fieldId);
      assignValue(linkOverride, row, fieldId);
      linkOverride.field = overridesConstants.LINK_VALUE;
      var clearSetInfo = getClearSetInfo(linkOverrides, linkOverride);
      if (clearSetInfo.isSettingOverride && clearSetInfo.clearOverrideIndex !== -1) {
        removeUnneededClearingOverrides(clearSetInfo, linkOverrides);
      }
      if (!clearSetInfo.isSettingOverride && clearSetInfo.setOverrideIndex !== -1) {
        // do not push clearing overrides when setting override exists
        return;
      } else {
        linkOverrides.push(linkOverride);

        //link type override
        var linkTypeOverride = prepareLinkTypeOverride(domain, row, fieldId);
        linkOverrides.push(linkTypeOverride);
      }
    });
    return linkOverrides;
  }
  function prepareSegmentLimitOverrides(row, gridId) {
    var segmentLimitOverrides = [];
    _.forEach(row._old, function (v, fieldId) {
      var actualField = fieldId;
      var domain = getDomain(gridId, actualField);
      if (!domain) {
        throw new Error('No domain mapping for grid: ' + gridId + ' and field: ' + actualField + ' when saving user adjustments.');
      }
      if (!(overridesUtilsService.isUserSegmentLimit(fieldId) || overridesUtilsService.isUserSegmentLimitType(fieldId))) {
        return;
      }
      var override = prepareKey(domain, row, fieldId);
      if (overridesUtilsService.isUserSegmentLimit(fieldId)) {
        // saving or deleting segment value + type as two different overrides
        assignValue(override, row, fieldId);
        var segmentLimitTypeOverride = prepareSegmentLimitTypeOverride(domain, row, fieldId);
        segmentLimitOverrides.push(segmentLimitTypeOverride);
      } else if (overridesUtilsService.isUserSegmentLimitType(fieldId)) {
        assignUserSegmentLimitTypeValue(override, row, fieldId);
      }
      segmentLimitOverrides.push(override);
    });
    return segmentLimitOverrides;
  }
  function prepareOverrides(data, gridId, scenario) {
    return _.reduce(data, function (result, row) {
      var minMaxOverrides = prepareMinMaxOverrides(row, gridId);
      var linkOverrides = prepareLinkOverrides(row, gridId);
      var simpleOverrides = prepareSimpleOverrides(row, gridId);
      var segmentLimitOverrides = prepareSegmentLimitOverrides(row, gridId);
      var allOverrides = _.concat(minMaxOverrides, simpleOverrides, linkOverrides, segmentLimitOverrides);
      _.each(allOverrides, function (override) {
        var domainIndex = _.findIndex(result, {
          domain: override.domain
        });
        if (domainIndex === -1) {
          result.push({
            domain: override.domain,
            requestBody: {
              userId: configurationService.getUserId(),
              scenario: scenario || DEFAULTS.SCENARIO,
              overrides: [override]
            }
          });
        } else {
          result[domainIndex].requestBody.overrides = _.concat(result[domainIndex].requestBody.overrides, override);
        }
      });
      return result;
    }, []);
  }
  return {
    prepareOverrides: prepareOverrides
  };
};
OverridesPreparationService.$inject = ['ConfigurationService', 'ScenarioConstants', 'OverridesConstants', 'OverridesKeyService', 'OverridesUtilsService'];
module.exports = OverridesPreparationService;